// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__UllRE","shake":"FloatingButton_shake__z6sag"};